import React from "react";
import { GridColDef } from "@mui/x-data-grid";
import { EditButton, DeleteButton } from "@refinedev/mui";

import { Avatar, TableCell, ActiveBannerSwitch } from "@shared/components";

export const useBannersListColumns = (
  onRefetch: () => void,
  translate: (key: string) => string,
): GridColDef[] => {
  return React.useMemo<GridColDef[]>(
    () => [
      {
        field: "id",
        headerName: translate("v1/banner_admin.fields.id"),
        minWidth: 20,
      },
      {
        field: "name",
        headerName: translate("v1/banner_admin.fields.name"),
        minWidth: 250,
        flex: 1,
      },
      {
        field: "image",
        headerName: translate("v1/banner_admin.fields.image"),
        minWidth: 80,
        align: "center",
        headerAlign: "center",
        renderCell: ({ value }) => (
          <TableCell.Container align="center">
            <Avatar
              src={value ?? "/images/image-icon-picture-not-available-picturer.jpeg"}
              alt="logo"
              shape="square"
              fullWidth
            />
          </TableCell.Container>
        ),
      },
      {
        field: "active",
        headerName: translate("v1/banner_admin.fields.active"),
        minWidth: 120,
        headerAlign: "center",
        renderCell: ({ value, row }) => (
          <TableCell.Container align="center">
            <ActiveBannerSwitch value={value} id={row.id}  />
          </TableCell.Container>
        ),
      },
      {
        field: "actions",
        headerName: translate("table.actions"),
        align: "center",
        headerAlign: "center",
        minWidth: 120,
        sortable: false,
        display: "flex",
        renderCell: ({ row }) => (
          <>
            <EditButton
              hideText
              recordItemId={row.id}
            />

            <DeleteButton
              hideText
              recordItemId={row.id}
              hidden={false}
              onSuccess={onRefetch}
            />
          </>
        ),
      },
    ],
    [translate, onRefetch]
  );
};
